<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('materialproductversion_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.productversion')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialproductversion-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.uuid') }}</strong></td>
              <td>
                {{ item['uuid'] }}
              </td>
              <td><strong>{{ $t('profile.material.product') }}</strong></td>
              <td>
                  <span v-if="item['materialProduct']">{{ item['materialProduct'].name }}</span><br>
                  <span v-if="item['materialProduct']">{{ item['materialProduct'].namefr }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.version') }}</strong></td>
              <td>
                {{ item['version'] }}
              </td>
              <td><strong>{{ $t('global.reference') }}</strong></td>
              <td>
                {{ item['reference'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.hub') }}</strong></td>
              <td>
                {{ item['public'] }}
              </td>
              <td><strong>{{ $t('global.comment') }}</strong></td>
              <td>
                {{ item['comment'] }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <ProducttypefileList v-if="item"
            ref="ProducttypefileList"
            :materialProductVersionParent="[item['@id']]"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import FileMixin from '../../mixins/FileMixin';
import ProducttypefileList from '../producttypefile/List';

const servicePrefix = 'MaterialProductVersion';

export default {
  name: 'MaterialProductVersionShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ProducttypefileList
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('materialproductversion', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialproductversion', ['find'])
  },
  methods: {
    ...mapActions('materialproductversion', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
